import React from 'react';
import { PORTAL_FIXTURE } from '../mock/portalFixture';
import { usePortalCopy } from '../PortalUi';
import { PortalStatus, coverageFrom, formatPremiumRecurring, formatTermYears } from '../api/portalService';
import { useCoverageLabels } from '../hooks/useCoverageLabels';

export function SummaryCard({ application }: { application?: PortalStatus | null }) {
  const t = usePortalCopy();
  const live = Boolean(application);
  const coverage = live ? coverageFrom(application) : PORTAL_FIXTURE.coverage;
  const term = live ? formatTermYears(application?.termYears) : PORTAL_FIXTURE.termYears;
  const premium = live ? formatPremiumRecurring(application?.premium ?? null) : PORTAL_FIXTURE.premiumMonthly;
  const holder = live ? (application?.applicantName || '') : PORTAL_FIXTURE.fullName;
  // ETAPA-1 tarifador: las coberturas adicionales contratadas, con su nombre. Es
  // lo que una nueva oferta puede QUITAR, así que el cliente tiene que verlas
  // antes en «lo que solicitaste». Sin add-ons la fila no se monta.
  const addOns = live ? application?.addOns ?? [] : [];
  const labels = useCoverageLabels(addOns.length > 0);

  return (
    <div className="sum">
      <h3>{t('summaryTitle')}</h3>
      <dl>
        <dt>{t('summaryCoverage')}</dt><dd>{coverage}</dd>
        <dt>{t('summaryTerm')}</dt><dd>{term}</dd>
        {addOns.length > 0 ? (
          <>
            <dt>{t('summaryAddOns')}</dt>
            <dd className="sum-addons" data-spec="o-summary-addons">
              {addOns.map((code) => labels[code] || code).join(', ')}
            </dd>
          </>
        ) : null}
        <dt>{t('summaryPremium')}</dt><dd>{premium}</dd>
        <dt>{t('summaryHolder')}</dt><dd>{holder}</dd>
        {live ? null : (
          <>
            <dt>{t('summaryBeneficiaries')}</dt><dd>{PORTAL_FIXTURE.beneficiaries}</dd>
          </>
        )}
      </dl>
    </div>
  );
}
